import React, { useRef } from 'react'
import useScrollLock from '../../../../hooks/useScrollLock';
import useClickOutside from '../../../../hooks/useClickOutside';
import { MdOutlineClose, MdAutorenew } from 'react-icons/md';
import Button from '../../../../components/Buttons/Button';
import ConfigFiltersDesktop from './desktop/ConfigFiltersDesktop';
import ConfigFiltersMobile from './mobile/ConfigFiltersMobile';
import { ConfigFilterModalProps } from './types';
import { useFilterColumns } from '../../hooks/useFilterColumns';
import { countDraft } from '../../utils/filterDraft';

const ConfigFilterModal = ({
    isOpen,
    toggle,
    disabledApply,
    disabledClean,
    onApply,
    onClean,
    draft,
    toggleField,
    setField,
}: ConfigFilterModalProps) => {
    const dialogLayoutRef = useRef<HTMLDivElement>(null);

    useClickOutside(dialogLayoutRef, toggle);
    useScrollLock(isOpen);

    const { chainColumns, independentColumns } = useFilterColumns({ draft, toggleField, setField });

    if (!isOpen) return null;

    return (
        <div className='container-dialog fixed top-0 left-0 w-full h-full motion-safe:animate-fade-in'>
            <div
                className='container-inner-modal-inner-filter bg-primary-100 shadow-custom-dual max-md:motion-safe:animate-modal-slide-in md:motion-safe:animate-modal-in'
                ref={dialogLayoutRef}
            >
                <div className='p-4 border-b border-brand-green-7 flex justify-between'>
                    <p className='text-brand-green-20 text-tmedium shrink-0'>CONFIGURAR FILTROS</p>
                    <button onClick={toggle} className="flex w-full justify-end sticky top-0">
                        <MdOutlineClose size={24} />
                    </button>
                </div>
                <div className='md:hidden'>
                    <ConfigFiltersMobile
                        chainColumns={chainColumns}
                        independentColumns={independentColumns}
                    />
                </div>
                <div className='hidden md:block'>
                    <ConfigFiltersDesktop
                        chainColumns={chainColumns}
                        independentColumns={independentColumns}
                    />
                </div>
                <div className='bg-brand-green-1 p-4 border-t border-t-brand-green-7 rounded-b-sm text-brand-green-30 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 md:gap-0 w-full bottom-0 fixed md:static'>
                    <p className='text-bmedium md:text-tmedium text-green-30'>Filtros seleccionados ({countDraft(draft)})</p>
                    <div className='flex gap-4 w-full md:w-max'>
                        <Button
                            label='Limpiar'
                            type='button'
                            showIconLeft={false}
                            showIconRight={true}
                            className='bg-primary-100 !w-full md:!w-max'
                            variant='outline-orange'
                            disabled={disabledClean}
                            onClick={onClean}
                            icon={MdAutorenew}
                            iconSize={18}
                        />
                        <Button
                            label='Aplicar filtros'
                            type='button'
                            showIconLeft={false}
                            showIconRight={false}
                            variant="primary"
                            disabled={disabledApply}
                            onClick={() => { onApply(); toggle(); }}
                            className='!w-full text-center md:!w-max'
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfigFilterModal